// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

//export const RPC_URL = 'https://www.onpowerusa.com/fleet/'; export const DISABLE_SAVES = true; //RDk Live server
//export const RPC_URL = 'http://192.168.10.108/fleet/'; export const DISABLE_SAVES = false; //RDK Dev server
export const RPC_URL = 'https://www.onpowerusa.com/fleet/'; export const DISABLE_SAVES = false; //RDk Live server with alt config

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
